import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiMail, FiLock, FiEye, FiEyeOff, FiLoader } from 'react-icons/fi';
import Input from '../components/Input';
import { apiClient, tokenManager } from '../utils/api';
import logo from '../components/Images/logo-green.svg';

const Login = ({ onLoginSuccess = () => {} }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }

    if (!formData.password) {
      newErrors.password = 'Password is required';
    } else if (formData.password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    
    try {
      // Make actual API call to dashboard/login
      const response = await apiClient.post('/login', {
        email: formData.email,
        password: formData.password
      });
      
      // Handle the response structure: the data is directly in response.data
      const data = response.data;

      console.log('Full response:', response);
      console.log('Response data:', response.data);
      console.log('Extracted data:', data);
      console.log('Data token:', data?.token);
      console.log('Data user:', data?.user);
      
      if (!data || !data.token) {
        console.error('Invalid response structure - missing token');
        throw new Error('Invalid response structure');
      }

      const token = data.token;
      
      // Store token and user data
      localStorage.setItem('authToken', data.token);
      console.log('Token stored:', token);
      console.log('Token from localStorage:', localStorage.getItem('authToken'));
      
      if (rememberMe) {
        localStorage.setItem('rememberMe', 'true');
      }
      
      // Call success callback with user data
      console.log('Calling onLoginSuccess with:', data.user);
      onLoginSuccess(data.user);
      console.log('onLoginSuccess called successfully');
      
      // Add a small delay to ensure state updates are processed
      setTimeout(() => {
        // Redirect to dashboard on successful login
        navigate('/dashboard');
      }, 100);
      
    } catch (error) {
      setErrors({
        general: error.response?.data?.message || error.message || 'Login failed. Please try again.'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDemoLogin = () => {
    setFormData({
      email: 'super-admin@example.com',
      password: 'Aa@12345678'
    });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 to-secondary-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        {/* Header */}
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center mb-4">
            <img src={logo} alt="Lynx Logo" className="object-contain" />  
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-2">
            Welcome back
          </h2>
          <p className="text-gray-600">
            Sign in to your Lynx Dashboard account
          </p>
        </div>

        {/* Login Form */}
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <form className="space-y-6" onSubmit={handleSubmit}>
            {/* General Error */}
            {errors.general && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                <p className="text-red-600 text-sm">{errors.general}</p>
              </div>
            )}

            {/* Email Field */}
            <Input
              label="Email Address"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              error={errors.email}
              placeholder="Enter your email"
              leftIcon={<FiMail />}
              required
              disabled={loading}
            />

            {/* Password Field */}
            <Input
              label="Password"
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              error={errors.password}
              placeholder="Enter your password"
              leftIcon={<FiLock />}
              showPasswordToggle
              required
              disabled={loading}
            />


            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className="w-full flex justify-center items-center px-4 py-3 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-primary-500 hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              {loading ? (
                <>
                  <FiLoader className="animate-spin mr-2 h-4 w-4" />
                  Signing in...
                </>
              ) : (
                'Sign in'
              )}
            </button>

            {/* Demo Login Button */}
            {/* <button
              type="button"
              onClick={handleDemoLogin}
              disabled={loading}
              className="w-full flex justify-center items-center px-4 py-3 border border-gray-300 rounded-lg shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              Use Demo Credentials
            </button> */}
          </form>

        </div>

      </div>
    </div>
  );
};

export default Login; 